import React from "react";
import {Grid, Typography} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import {ValidationState} from "./usePasswordValidation";
import {styled} from "@mui/system";
import {useLxTranslations} from "@lxo-blocks/react";
import {PASSWORD_INPUT_TRANSLATION} from "./PasswordInput.translation.de";

const PREFIX = 'PasswordHint';
const classes = {
    iconText: `${PREFIX}-iconText`,
    iconPlacement: `${PREFIX}-iconPlacement`
}
const StyledDiv = styled('div')(({theme}) => ({
    [`.${classes.iconText}`]: {
        marginLeft: theme.spacing(1),
    },
    [`&.${classes.iconPlacement}`]: {
        display: "flex",
        alignItems: "center",
    },
}));

export const PasswordHint = React.forwardRef<any, any>((props, ref) => {
    const {t} = useLxTranslations(PASSWORD_INPUT_TRANSLATION);

    let criterias = [
        {
            text: t("PASSWORD_HINT_8_CHARS"),
            field: "length",
        },
        {
            text: t("PASSWORD_HINT_UPPER_CASE"),
            field: "upperCase",
        },
        {
            text: t("PASSWORD_HINT_NUMBER_OR_SPECIAL_CHAR"),
            field: "numberSpecialChar",
        },
        {
            text: t("PASSWORD_HINT_LOWER_CASE"),
            field: "lowerCase",
        },
    ];

    return (
        <Grid container spacing={1}>
            {criterias.map((criteria) => (
                <Grid key={criteria.text} item xs={12} sm={6}>
                    <Criteria
                        text={criteria.text}
                        state={props.criterias[criteria.field]}
                    />
                </Grid>
            ))}
        </Grid>
    );
});

function Criteria(props: any) {
    return (
        <>
            {props.state === ValidationState.INIT && (
                <CriteriaInit text={props.text}/>
            )}
            {props.state === ValidationState.VALID && (
                <CriteriaValid text={props.text}/>
            )}
            {props.state === ValidationState.INVALID && (
                <CriteriaInvalid text={props.text}/>
            )}
        </>
    );
}

function CriteriaInit(props: any) {
    return (
        <StyledDiv className={classes.iconPlacement}>
            <CancelIcon fontSize="small" color="disabled"/>
            <Typography
                className={classes.iconText}
                variant="caption"
                color="textSecondary"
            >
                {props.text}
            </Typography>
        </StyledDiv>
    );
}

function CriteriaValid(props: any) {
    return (
        <StyledDiv className={classes.iconPlacement}>
            <CheckIcon fontSize="small" color="primary"/>
            <Typography
                className={classes.iconText}
                variant="caption"
                color="primary"
            >
                {props.text}
            </Typography>
        </StyledDiv>
    );
}

function CriteriaInvalid(props: any) {
    return (
        <StyledDiv className={classes.iconPlacement}>
            <CancelIcon fontSize="small" color="error"/>
            <Typography className={classes.iconText} variant="caption" color="error">
                {props.text}
            </Typography>
        </StyledDiv>
    );
}
